// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3EOdQ","overflowing":"ReadFullNote_overflowing__30q5z"};